module.exports = __webpack_public_path__ + "img/green.dc4ceba1.gif";